import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import './technicalMaintenanceShared.css';

export const formatDisplayDate = (value) => {
  if (!value) return '—';
  const iso = String(value).slice(0, 10);
  const [year, month, day] = iso.split('-');
  if (!year || !month || !day) return value;
  return `${day}.${month}.${year}`;
};

export const fmtMoney = (value) => {
  if (value == null || value === '') return '—';
  return Number(value).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const daysLabel = (days) => {
  if (days === 0) return 'Bugün';
  if (days < 0) return `${Math.abs(days)} gün gecikmiş`;
  return `${days} gün kaldı`;
};

export const scheduleBadgeClass = (days, kind) => {
  if (kind === 'planned') return 'planned';
  if (days < 0) return 'overdue';
  if (days <= 7) return 'soon';
  return 'ok';
};

export const statusBadgeClass = (status) => {
  if (status === 'completed') return 'status-completed';
  if (status === 'in_progress') return 'status-progress';
  if (status === 'cancelled') return 'status-cancelled';
  return 'status-planned';
};

export const TechnicalMaintenancePageShell = ({
  title,
  subtitle,
  backTo,
  backLabel = 'Geri',
  actions,
  children,
}) => (
  <div className="tm-page">
    <div className="tm-page-header">
      <div>
        {backTo ? (
          <Link to={backTo} className="tm-back-link">
            <ArrowLeftIcon className="h-4 w-4" />
            {backLabel}
          </Link>
        ) : null}
        <h1 className="tm-page-title">{title}</h1>
        {subtitle ? <p className="tm-page-subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
    {children}
  </div>
);

export const StatCard = ({ label, value, accent = 'rgb(37 99 235)' }) => (
  <div className="tm-kpi-card" style={{ '--tm-accent': accent }}>
    <span className="tm-kpi-label">{label}</span>
    <div className="tm-kpi-value">{value}</div>
  </div>
);

export const EmptyState = ({ message }) => (
  <div className="tm-dash-empty">{message}</div>
);

export const MaintenanceListCard = ({
  title,
  subtitle,
  area,
  date,
  badgeLabel,
  badgeClass,
  excerpt,
  onClick,
}) => (
  <article className="tm-record-card" onClick={onClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && onClick?.()}>
    <div className="tm-record-card-main">
      <h3 className="tm-record-card-title">{title}</h3>
      <div className="tm-record-card-meta">
        {area ? <span className="tm-badge area">{area}</span> : null}
        {subtitle ? <span>{subtitle}</span> : null}
      </div>
      {excerpt ? <p className="tm-record-card-excerpt">{excerpt}</p> : null}
    </div>
    <div className="tm-record-card-side">
      <div className="tm-record-card-date">{date}</div>
      {badgeLabel ? <span className={`tm-badge ${badgeClass}`}>{badgeLabel}</span> : null}
    </div>
  </article>
);
